export default function api(url, method, params) {
    const request = {
        credentials: 'include',
    };

    if (method) {
        request.method = method;
    }

    if (params) {
        request.body = JSON.stringify(params);
        request.headers = {
            'content-type': 'application/json',
        };
    }

    return new Promise((resolve, reject) => {
        fetch(url, request).then(response => {
            if (!response.ok) {
                return reject(response);
            }
            return resolve(response.json());
        }, reject);
    });
}

export function sendFile(url, method, params) {
    const request = {
        credentials: 'include',
    };

    if (method) {
        request.method = method;
    }

    if (params) {
        const formData = new FormData();
        Object.keys(params).forEach(key => {
            formData.append(key, params[key]);
        });
        request.body = formData;
    }

    return new Promise((resolve, reject) => {
        fetch(url, request).then(response => {
            if (!response.ok) {
                return reject(response);
            }
            return resolve(response.json());
        }, reject);
    });
}



// WEBPACK FOOTER //
// ./src/helpers/api.js